/**
 * Cache wrapper for "shifts since cutoff". TtlCache keyed by the cutoff ISO so a calendar-day
 * rollover invalidates correctly. Wraps `API.Data.Shifts.get.byFilter` for the underlying
 * fetch.
 */

import { Shift } from "@domain/CRM/shift";
import { TtlCache } from "../../../cache/ttlCache";
import { API } from "../../../api";

const SINCE_CUTOFF_TTL_MS = 15 * 60 * 1000;

class CachedShiftsSinceCutoff {
	private cache = new TtlCache<string, Shift[]>(SINCE_CUTOFF_TTL_MS, (cutoffIso) =>
		API.Data.Shifts.get.byFilter({
			fields: { startDate: { operator: ">=", value: cutoffIso } },
		}),
	);

	/** Synchronous TTL cache hit for the given cutoff, or null if missing/expired. */
	public peek(cutoff: Date): Shift[] | null {
		return this.cache.peek(cutoff.toISOString());
	}

	public get(cutoff: Date): Promise<Shift[]> {
		return this.cache.get(cutoff.toISOString());
	}

	public clear(): void {
		this.cache.clear();
	}
}

export class CachedShiftsAPI {
	public sinceCutoff = new CachedShiftsSinceCutoff();
}
